// test2152
(2152 && 0);
